var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import { psService } from 'ziphy-web-shared/basic/api';
import { downloadBy } from 'ziphy-web-shared/basic/helpers';
import { showAlert } from 'ziphy-web-shared/basic/lib/utilities';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import MediaViewerModal from '@library/media/MediaViewer.modal';
const ViewNotesPdfButton = ({ encounterId, provenanceRef, hasDocument, hasDocumentError = false, date, renderItem, fileName = 'Note.pdf', title, errorLimit = 0, }) => {
    const { t } = useTranslation();
    const [isRequesting, setIsRequesting] = useState(false);
    const hasError = hasDocumentError ||
        (errorLimit > 0 && !hasDocument && moment().diff(date, 'minutes') >= errorLimit);
    const isLoading = !hasError && !hasDocument;
    const handleViewOrDownload = (view) => __awaiter(void 0, void 0, void 0, function* () {
        if (isLoading || isRequesting) {
            showAlert.error(t('alert.pdf_notes_preparing'));
            return;
        }
        setIsRequesting(true);
        try {
            let { prepared: result } = yield psService.readNotesPdf({
                encounterId,
                provenanceRef,
                urlParams: {
                    viewUrl: { 'ResponseContentDisposition|strict': `inline;filename=${fileName}` },
                    downloadUrl: { 'ResponseContentDisposition|strict': `attachment;filename=${fileName}` },
                },
            });
            if (result.viewUrl && result.downloadUrl) {
                if (view) {
                    $modal.add(MediaViewerModal, {
                        items: [
                            {
                                contentType: 'application/pdf',
                                url: result.viewUrl,
                                downloadParams: { url: result.downloadUrl, target: '_self' },
                                title: title || t('label.notes'),
                            },
                        ],
                    });
                }
                else {
                    downloadBy({ url: result.downloadUrl });
                }
            }
            else {
                showAlert.error(t('alert.pdf_notes_error'));
            }
        }
        catch (error) {
            showAlert.error(t('alert.pdf_notes_error'));
        }
        finally {
            setIsRequesting(false);
        }
    });
    return (_jsx(_Fragment, { children: renderItem({
            isLoading,
            isRequesting,
            autoTarget: { onClick: () => handleViewOrDownload(true) },
        }) }));
};
export default observer(ViewNotesPdfButton);
